const STORAGE_KEY_PREFIX = 'ies.headerNotifications.read';

/**
 * Đọc tập id đã xem từ `localStorage` theo user.
 *
 * @param userId - Id người dùng; `null` dùng namespace khách/ẩn danh.
 * @returns Set id thông báo đã đánh dấu đã đọc.
 */
export function loadReadNotificationIds(userId: string | null): Set<string> {
  const key = userId ? `${STORAGE_KEY_PREFIX}:v1:${userId}` : `${STORAGE_KEY_PREFIX}:v1:anon`;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((x): x is string => typeof x === 'string'));
  } catch {
    return new Set();
  }
}

/**
 * Ghi toàn bộ id đã đọc (ghi đè).
 */
export function saveReadNotificationIds(userId: string | null, ids: Set<string>): void {
  const key = userId ? `${STORAGE_KEY_PREFIX}:v1:${userId}` : `${STORAGE_KEY_PREFIX}:v1:anon`;
  try {
    localStorage.setItem(key, JSON.stringify([...ids]));
  } catch {
    /* quota / private mode */
  }
}
